export const CONNECT_TO_WEB_SOCKET = 'booking/CONNECT_TO_WEB_SOCKET';

//staff practitioner

export const LOAD_STAFF_PRACTITIONER_LIST =
  'booking/LOAD_STAFF_PRACTITIONER_LIST';

export const LOAD_STAFF_PRACTITIONER_LIST_SUCCESS =
  'booking/LOAD_STAFF_PRACTITIONER_LIST_SUCCESS';

export const LOAD_STAFF_PRACTITIONER_LIST_ERROR =
  'booking/LOAD_STAFF_PRACTITIONER_LIST_ERROR';

//Booking slot
export const LOAD_BOOKING_SLOT_LIST = 'booking/LOAD_BOOKING_SLOT_LIST';

export const LOAD_BOOKING_SLOT_LIST_SUCCESS =
  'booking/LOAD_BOOKING_SLOT_LIST_SUCCESS';

export const LOAD_BOOKING_SLOT_LIST_LIST_ERROR =
  'bookingTimeSlot/LOAD_BOOKING_SLOT_LIST_LIST_SUCCESS';

//Next available Booking slot
export const LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST =
  'booking/LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST';

export const LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_SUCCESS =
  'booking/LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_SUCCESS';

export const LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_LIST_ERROR =
  'bookingTimeSlot/LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_LIST_SUCCESS';

export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export const SET_PREVIOUS_STEP = 'SET_PREVIOUS_STEP';
export const SET_IS_FROM_EXTERNAL_SOURCE = 'SET_IS_FROM_EXTERNAL_SOURCE';

export const LOAD_BOOKING_SLOT_LIST_ERROR =
  'booking/LOAD_BOOKING_SLOT_LIST_ERROR';

//hold pob booking slot
export const HOLD_BOOKING_SLOT = 'booking/HOLD_BOOKING_SLOT';
export const HOLD_BOOKING_SLOT_SUCCESS = 'booking/HOLD_BOOKING_SLOT_SUCCESS';
export const HOLD_BOOKING_SLOT_ERROR = 'booking/HOLD_BOOKING_SLOT_ERROR';

export const SET_HOLD_BOOKING_SLOT = 'booking/SET_HOLD_BOOKING_SLOT';

//release pob booking slot
export const RELEASE_BOOKING_SLOT = 'booking/RELEASE_BOOKING_SLOT';
export const RELEASE_BOOKING_SLOT_SUCCESS =
  'booking/RELEASE_BOOKING_SLOT_SUCCESS';
export const RELEASE_BOOKING_SLOT_ERROR = 'booking/RELEASE_BOOKING_SLOT_ERROR';

//create booking

export const CREATE_BOOKING = 'booking/CREATE_BOOKING';
export const CREATE_BOOKING_SUCCESS = 'booking/CREATE_BOOKING_SUCCESS';
export const CREATE_BOOKING_ERROR = 'booking/CREATE_BOOKING_ERROR';
